<template>
    <div class="searchHistory">
        <div class="history" >
            <div class="title">搜索历史<span @click="onDel"><img src="../../../../assets/img/b2b/del.png" alt=""></span></div>
            <div class="list">
                <span v-for="item in searchListArray" :key='item' @click="submitVal(item)" v-text="item"></span>
            </div>
        </div>
        <div class="history" >
            <div class="title">热门搜索</div>
            <div class="list">
                <span v-for="item in hotSearchArray" :key='item' @click="submitVal(item)" v-show="item" v-text="item"></span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        searchListArray: {
            type: Array,
            default: () => {
                return []
            }
        },
        hotSearchArray: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    methods: {
        onDel () {
            this.$emit('delClick')
        },
        submitVal (val) {
            this.$emit('onSearchVal', val)
        }
    }
}
</script>
<style lang='scss' scoped>
    .searchHistory {
        background: #ffffff;
        height: 100%;
        .history{
            padding: 36px 24px 0;
            .title{
                font-size: 28px;
                color: #333333;
                font-weight: 500;
                span{
                    float: right;
                    width: 32px;
                    height: 32px;
                }
            }
            .list {
                font-size: 24px;
                display: flex;
                flex-wrap: wrap;
                align-content: flex-start;
                span {
                    border-radius: 62px;
                    background: #F8F8F8;
                    margin-top: 20px;
                    margin-right: 20px;
                    line-height: 62px;
                    height: 62px;
                    padding: 0 28px;
                    color: #5C5C5C;
                    box-sizing: border-box;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    word-wrap: break-word;
                    word-break: break-all;
                    overflow: hidden;
                }
            }
        }
    }
</style>